import React, { Component } from "react";
import { connect } from "react-redux";
import messages from "./Plan.messages";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardImg,
  Table,
  Nav,
  NavLink,
} from "reactstrap";
import moment from "moment";
import Promise from "bluebird";

import * as actions from "../../../../redux/user/actions";

import {
  isCreatingCustomer,
  isCreatingSubscription,
} from "../../../../redux/user";

import type User from "../../../models/User";
import type Plan from "../../../models/Plan";
import { Link } from "react-router-dom";
import GradientButton from "../../../../components/input/GradientButton";

type Props = {
  currentPlanId: string,
  currentPlanName: string,
  singleExpired: boolean,
  trialExpired: boolean,
  plan: Plan,
  onRequestSubscribePlan: () => Promise<void>,
};

type StateProps = {};

type State = {
  isSelectedPlan: boolean,
};

class PlanView extends Component {
  props: Props;
  state: State = {
    isSelectedPlan: false,
  };

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {}

  componentDidUpdate() {}

  // Don't show a current plan if planId is empty
  isCurrentPlan = () => {
    return (
      this.props.currentPlanName === this.props.plan.name ||
      this.props.currentPlanId == this.props.plan.planId ||
      (this.props.currentPlanId === "plan_CnLZ1BqX5wdXeN" &&
        this.props.plan.name === "Basic")
    );
    // This hard coded ID is to compensate for the accidentally deleted "Basic" (free) plan on stripe.
  };

  handleSelectPlan = () => {
    this.setState({
      isSelectedPlan: true,
    });
    this.props.onRequestSubscribePlan();
  };

  render() {
    const plan = this.props.plan;
    const subscriptionExpired =
      this.isCurrentPlan() &&
      ((this.props.currentPlanName === "Trial" && this.props.trialExpired) ||
        (this.props.currentPlanName === "Single" && this.props.singleExpired));

    return (
      <div className="col-lg-4 col-md-6 col-sm-6">
        <Card>
          <CardHeader>
            {this.isCurrentPlan()
              ? plan.name + ` (${subscriptionExpired ? "Expired" : "Current"})`
              : plan.name}
          </CardHeader>
          <CardBody className="plan-body">
            <div className="plan-description">
              <h2>{plan.price}</h2>
              <p>{plan.details}</p>
              <ul>{plan.bullets.map(this.renderBullet)}</ul>
            </div>
            {this.isCurrentPlan() ? null : this.renderAddButton()}
          </CardBody>
        </Card>
      </div>
    );
  }

  renderAddButton() {
    return (
      <GradientButton
        disabled={
          this.props.isCreatingSubscription && this.state.isSelectedPlan
        }
        gradient="1/1"
        handleClick={this.handleSelectPlan}
        title={
          this.props.isCreatingSubscription && this.state.isSelectedPlan
            ? "Subscribing..."
            : "Select Plan"
        }
      />
    );
  }

  renderBullet(bullet: string) {
    return <li key={bullet}>{bullet}</li>;
  }
}

const mapStateToProps = (state) => {
  return {
    isCreatingCustomer: isCreatingCustomer(state),
    isCreatingSubscription: isCreatingSubscription(state),
  };
};

export default connect(mapStateToProps, actions)(PlanView);



// WEBPACK FOOTER //
// ./src/views/user/subscription/plan/Plan.js